import { Suspense } from 'react';
import { Box } from '@givebutter/primitives/box';
import { Loader } from '@givebutter/primitives/loader';
import { Separator } from '@givebutter/primitives/separator';
import { LetterDetailsRow } from 'assets/js/pages/engage/letters/LetterDetailsRow';
import { RecipientCountButton } from 'assets/js/pages/engage/letters/RecipientCountButton';
import { transformGeneratePdfLetterForToReadable } from 'assets/js/pages/engage/letters/transform';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useLetterMeta } from 'assets/js/pages/engage/letters/useLetterMeta';
import { useLetterRecipientContactFilter } from 'assets/js/pages/engage/letters/useLetterRecipientContactFilter';
import * as Tooltip from 'components/tooltip';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LetterConfirmationDetails = () => {
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    const { isOnConfirm } = useLetterMeta();
    const recipientsOnClick = useLetterRecipientContactFilter();

    if (!letter) {
        return null;
    }

    return (
        <Box className={'flex flex-col gap-4 px-6 py-4'}>
            <p className={'text-xl font-medium'}>Details</p>
            <Separator className={'-mx-6 !w-auto'} />
            <div className={'flex flex-col gap-6'}>
                <LetterDetailsRow
                    path={
                        !isOnConfirm
                            ? `/accounts/${accountId}/engage/letters/${letter.id}/edit`
                            : undefined
                    }
                    label={'Name'}
                >
                    <p className={'text-base text-gray-700'}>{letter.internal_name}</p>
                </LetterDetailsRow>
                {!!letter.description && letter.description.length > 0 && (
                    <LetterDetailsRow
                        path={
                            !isOnConfirm
                                ? `/accounts/${accountId}/engage/letters/${letter.id}/edit`
                                : undefined
                        }
                        label={'Description'}
                    >
                        <p className={'text-base text-gray-700'}>{letter.description}</p>
                    </LetterDetailsRow>
                )}
                <LetterDetailsRow
                    label={'Recipients'}
                    path={`/accounts/${accountId}/engage/letters/draft/${letter.id}/edit/filters`}
                    hideEditButton={!isOnConfirm}
                >
                    <Tooltip.Root>
                        <Tooltip.Trigger asChild={true}>
                            <RecipientCountButton
                                className={'text-base'}
                                onClick={recipientsOnClick}
                            />
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className={`!px-3 !py-2 ${isOnConfirm ? 'hidden' : ''}`}
                                inverse={true}
                            >
                                <p className={'text-white'}>View in Contacts</p>
                                <Tooltip.Arrow inverse={true} />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </LetterDetailsRow>
                <LetterDetailsRow hideEditButton={!isOnConfirm} label={'Generate letter for'}>
                    <p className={'text-base text-gray-700'}>
                        {transformGeneratePdfLetterForToReadable(
                            letter.settings.generate_letter_for,
                        )}
                    </p>
                </LetterDetailsRow>
            </div>
        </Box>
    );
};

const WrappedLetterConfirmationDetails = () => (
    <Suspense fallback={<Loader />}>
        <LetterConfirmationDetails />
    </Suspense>
);

export { WrappedLetterConfirmationDetails as LetterConfirmationDetails };
